module.exports = __webpack_public_path__ + "img/companyinf_addposi_img.34d8bc07.webp";